import React, { useState, useEffect, useRef, useCallback } from 'react';
import { HOST } from "../../store/types";
import { Redirect, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import Tabs from '../../components/Tabs/Tabs.jsx'
import TabsDescription from '../../components/Tabs-description/Tabs-description.jsx'
import TabsFoto from '../../components/Tabs-foto/Tabs-foto.jsx'
import TabsVideo from '../../components/Tabs-video/Tabs-video.jsx'
import TabsAdditional from '../../components/Tabs-additional/Tabs-additional.jsx'
import {
  LineStyled,
} from './style.js';

import i18n from "i18next";

import { Container } from "../../components/Container/Container";
import HeaderPage from "../../components/HeaderPage/HeaderPage";
import Grid from "../../components/Grid/Grid";
import { ContainerCatalogStyled } from "../../components/Container/style";

const getSlug = (pathname) => pathname.substr(pathname.indexOf('/', 1) + 1);

//для компонента Grid — значение не менялось за всё время жизни компонента
const chooseCard = false;

const Project = () => {
  const [popupIsOpen, setPopupIsOpen] = useState(false);
  const [fotosIndex, setFotosIndex] = useState(0);
  const [trailer, setTrailer] = useState(false);
  //для компонента Grid
  const [dashboard] = useState(true);
  //контент
  const [contentPage, setContentPage] = useState([]);
  const [redirect, setRedirect] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sendRequest, setSendRequest] = useState(false);

  const token = useSelector((store) => store.auth.dataToken.token);
  const isLoggedIn = useSelector((store) => store.auth.isLoggedIn);
  const favoritesMessage = useSelector((store) => store.favorites.message);

  const location = useLocation();

  const isMounted = useRef(true);
  useEffect(() => () => { isMounted.current = false }, []);

  const timers = useRef([]);
  useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

  const handleClick = (id, statusTreiler) => {
    setPopupIsOpen((prev) => !prev);
    setFotosIndex(id);
    setTrailer(statusTreiler);
  };

  const handleClickPlus = () => {
    setFotosIndex((prev) => prev + 1);
  };

  const handleClickMinus = () => {
    setFotosIndex((prev) => prev - 1);
  };

  //Получаем содержимое страницы
  const _onContentPage = useCallback((slug, authToken) => {
    let bearer;
    if (authToken) {
      bearer = 'Bearer ' + authToken
    }
    fetch(`${HOST}/v1/projects/${slug}`, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Authorization': bearer,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        return res.json();
      })
      .then((body) => {
        if (!isMounted.current) return;

        if (!body.id) { //404 редирект
          setRedirect(true);
        }

        setContentPage(body);
      });
  }, []);

  // componentDidMount + componentDidUpdate: загрузка и переход на другой проект
  useEffect(() => {
    _onContentPage(getSlug(location.pathname), token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // componentDidUpdate: всплывающее окно для кнопок
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setSendRequest(favoritesMessage[0] === true ? "Запрос отправлен" : "Запрос уже существует");
    timers.current.push(setTimeout(() => {
      setSendRequest(false);
    }, 1500));
  }, [favoritesMessage]);

  //редирект на 404
  if (redirect) { return <Redirect to='/404' />; }

  let categoryGenres = [contentPage.category && contentPage.category.title];
  contentPage.genres && contentPage.genres.map((item) => { return (categoryGenres.push(item.title)) });
  // режиссеры
  let directors = [];
  contentPage.directors && contentPage.directors.map((item) => { return (directors.push(item.full_name)) });
  // сценаристы
  let screenwriters = [];
  contentPage.screenwriters && contentPage.screenwriters.map((item) => { return (screenwriters.push(item.full_name)) });
  // продюсеры
  let producers = [];
  contentPage.producers && contentPage.producers.map((item) => { return (producers.push(item.full_name)) });
  // актеры
  let actors = [];
  contentPage.actors && contentPage.actors.map((item) => { return (actors.push(item.full_name)) });
  // операторы
  let operators = [];
  contentPage.operators && contentPage.operators.map((item) => { return (operators.push(item.full_name)) });
  // эпизоды
  let episodes = [];
  contentPage.data && (contentPage.data.episodes && delete contentPage.data.episodes[""]);
  contentPage.data && (contentPage.data.episodes && (episodes = Object.values(contentPage.data.episodes)));
  let seasonsNow = []
  seasonsNow = contentPage.data && (contentPage.data.episodes && Object.keys(contentPage.data.episodes));

  // эпизоды для полей "колличество сезонов" и "колличество эпизодов"
  let numberSeasons = (contentPage.seasons && (!contentPage.episodes_count && !contentPage.seasons_count)) ? contentPage.seasons.map(() => { return ([]) }) : [];
  let numberEpisodes = [];
  contentPage.seasons && contentPage.seasons.map((item) => { return (numberEpisodes.push(item.episodes_amount)) });

  // трейлеры
  let channel = "";
  contentPage.data && (contentPage.data.trailers && (channel = Object.values(contentPage.data.trailers)));

  // превью кадры
  let cadresSmall = [];
  contentPage.data && (contentPage.data.cadres && contentPage.data.cadres.map((item) => { return (cadresSmall.push(item.media_preview)) }));

  // кадры
  let cadres = [];
  contentPage.data && (contentPage.data.cadres && contentPage.data.cadres.map((item) => { return (cadres.push(item.media)) }));


  // постеры
  let posters = [];
  contentPage.data && (contentPage.data.posters && contentPage.data.posters.map((item) => { return (posters.push(item.media)) }));

  // доп материалы / кадры
  let extraImg = [];
  contentPage.data_extra && (contentPage.data_extra.cadres && (extraImg = Object.values(contentPage.data_extra.cadres)));
  // доп материалы / видео
  let extraVideos = [];
  contentPage.data_extra && (contentPage.data_extra.other_videos && (extraVideos.push(Object.values(contentPage.data_extra.other_videos))));
  contentPage.data_extra && (contentPage.data_extra.trailers && (extraVideos.push(Object.values(contentPage.data_extra.trailers))));
  contentPage.data_extra && (contentPage.data_extra.episodes && (extraVideos.push(Object.values(contentPage.data_extra.episodes)[0])));
  // доп материалы / файлы
  let extraMaterials = [];
  contentPage.data_extra && (contentPage.data_extra.files && (extraMaterials = Object.values(contentPage.data_extra.files)));

  const testProject = {
    description: [
      { name: i18n.t(`catalog.project.${0}.year_of_production`), text: (!contentPage.year_start ? '...' : contentPage.year_start) + (!contentPage.year_end ? ' — <div style="background: #42A5F5;font-size: 12px;border-radius: 21px;padding: 8px 10px;color: #fff;display: inline;">В процессе</div>' : contentPage.year_end === contentPage.year_start ? "" : (" - " + contentPage.year_end)) },
      { name: i18n.t(`catalog.project.${0}.runtime`), text: contentPage.duration ? String(contentPage.duration) + " " + i18n.t(`catalog.project.${0}.min`) : "" },
      { name: i18n.t(`catalog.project.${0}.seasons`), text: contentPage.seasons ? (contentPage.seasons && (contentPage && !contentPage.seasons_count)) ? contentPage.seasons.length : String(contentPage && contentPage.seasons_count) : "" },
      { name: i18n.t(`catalog.project.${0}.col_episodes`), text: contentPage.seasons ? (contentPage.seasons && (contentPage && !contentPage.episodes_count)) ? contentPage.seasons.reduce((sum, item) => { return sum + item.episodes_amount }, 0) : String(contentPage && contentPage.episodes_count) : "" },
      { name: i18n.t(`catalog.project.${0}.PG`), text: contentPage.age_restriction ? String(contentPage.age_restriction) + "+" : "" },
      { name: i18n.t(`catalog.project.${0}.production`), text: (contentPage.production ? contentPage.production.title : "") },
      { name: i18n.t(`catalog.project.${0}.director`), text: directors.length > 0 && directors.join(', ') },
      { name: i18n.t(`catalog.project.${0}.screenwriter`), text: screenwriters.length > 0 && screenwriters.join(', ') },
      { name: i18n.t(`catalog.project.${0}.producer`), text: producers.length > 0 && producers.join(', ') },
      { name: i18n.t(`catalog.project.${0}.actors`), text: actors.length > 0 && actors.join(', ') },
      { name: i18n.t(`catalog.project.${0}.actors`), text: operators.length > 0 && operators.join(', ') }
      // {name: "Оператор", text: operators.length > 0 && operators.join(', ') : " ... "}
    ],
    moreDetails: null,
  }

  const tabsMenu = [
    { tabsName: i18n.t(`catalog.project.${0}.description`) },
    //  { tabsName: (((episodes.length > 0 || channel.length > 0) && isLoggedIn) && i18n.t(`catalog.project.${0}.video`)) },
    { tabsName: (((episodes.length > 0 || channel.length > 0)) && i18n.t(`catalog.project.${0}.video`)) },
    { tabsName: (posters.length > 0 || cadres.length > 0) && i18n.t(`catalog.project.${0}.photo`) },
    { tabsName: (extraImg.length > 0 || extraVideos.length > 0 || extraMaterials.length > 0) && i18n.t(`catalog.project.${0}.additional_materials`) }
  ]
  // Rightdiv={(i18n.language === 'en') ? '/images/default-top-img-en.png' : '/images/default-top-img-ru.png'}
  return (
    <>
      <HeaderPage
        Leftimg={(i18n.language === 'en') ? (contentPage.image_en === "" ? "../img-test/default-card-img.jpg" : contentPage.image_en) : (contentPage.image_ru === "" ? "../img-test/default-card-img.jpg" : contentPage.image_ru)}
        Rightdiv={(i18n.language === 'en') ? (contentPage.trailer_poster_en === "" ? '/images/default-top-img-en.png' : contentPage.trailer_poster_en) : (contentPage && contentPage.trailer_poster_ru === "" ? '/images/default-top-img-ru.png' : contentPage.trailer_poster_ru)}
        Rightvideo={contentPage.trailer_embed} />

      <ContainerCatalogStyled>
        <Container>
          {/* компонент табов - в пропсах передаем меню и компоненты вкладок*/}
          <Tabs
            tabsMenu={tabsMenu}
            imgPoster={(i18n.language === 'en') ? (contentPage.poster_en === "" ? "../img-test/default-card-img.jpg" : contentPage.poster_en) : (contentPage.poster_ru === "" ? "../img-test/default-card-img.jpg" : contentPage.poster_ru)}
            textSend={i18n.t(`catalog.project.${0}.get_in_touch_with_the_manager`)}
            id={contentPage.id && contentPage.id}
            isInFavourites={contentPage.isInFavourites && contentPage.isInFavourites}
            typeBookmark="catalog"
            isLoggedIn={isLoggedIn}

            firstTabs={<TabsDescription
              header={true}
              name={contentPage.title}
              genre={categoryGenres}
              description={testProject.description}
              smallDescription={contentPage.tagline}
              bigDescription={contentPage.description ? contentPage.description : ""}
              moreDetails={testProject.moreDetails ? testProject.moreDetails : ""}
              is_format={contentPage.is_format}
              channel={contentPage.channel && contentPage.channel.slug}
              channelLogo={contentPage.channel && ((i18n.language === 'en') ? contentPage.channel.logo_en : contentPage.channel.logo_ru)}
              episodes={episodes}
              numberSeasons={numberSeasons}
              numberEpisodes={numberEpisodes}
              seasonsDes={contentPage.seasons && contentPage.seasons}
              id={contentPage.id && contentPage.id}
              isInFavourites={contentPage.isInFavourites && contentPage.isInFavourites}
              typeBookmark="catalog"
            />}

            secondTabs={<TabsVideo
              season={episodes}
              trailerBlock={channel}
              handleClickMinus={handleClickMinus}
              handleClickPlus={handleClickPlus}
              handleClick={handleClick}
              popupIsOpen={popupIsOpen}
              fotosIndex={fotosIndex}
              trailer={trailer}
              seasonsNow={seasonsNow}
            />}

            thirdTabs={
              <TabsFoto
                posters={posters}
                cadresSmall={cadresSmall}
                cadre={cadres}
                handleClickMinus={handleClickMinus}
                handleClickPlus={handleClickPlus}
                handleClick={handleClick}
                popupIsOpen={popupIsOpen}
                fotosIndex={fotosIndex}
                project={true}
              />}

            fourthTabs={<TabsAdditional
              extraImg={extraImg}
              extraVideos={extraVideos}
              extraMaterials={extraMaterials}
            />}
          />
          <LineStyled></LineStyled>
          <Container padding="true">
            {contentPage.related_projects && <Grid
              type="catalog"
              title={i18n.t(`catalog.project.${0}.see_also`)}
              cards={contentPage.related_projects}
              //cardsLength={collection.length}
              tile={dashboard}
              chooseCard={chooseCard}
            />}
          </Container>
        </Container>
      </ContainerCatalogStyled>
    </>
  );
};

export default Project;
